<template>
    <div>
        <CRow>
            <CCol>
                <CCard>
                    <CCardHeader>
                        <strong>Создание магазина продуктов</strong>
                    </CCardHeader>

                    <CCardBody>
                        <GrocerUpsertForm @success="$router.push('/grocers')" @dismiss="$router.go(-1)" />
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import GrocerUpsertForm from '@/components/grocers/GrocerUpsertForm'

    export default {
        name: 'GrocerCreate',

        components: {
            GrocerUpsertForm,
        },
    }
</script>

<style>

</style>
